// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1P507","box":"WorkspacesBox_box__ttqSH","node":"WorkspacesBox_node__3zEZd"};